module.exports = __webpack_public_path__ + "img/camp_shirt_gk4.feef9129.svg";